type BaseState = {
  isLoading: unknown;
  error: unknown;
};

export function selectBase<T extends BaseState>(
  state: T
): { isLoading: T['isLoading']; error: T['error'] } {
  return {
    isLoading: state.isLoading,
    error: state.error,
  };
}

export function selectData<T extends { data: unknown } & BaseState>(
  state: T
): { data: T['data'] } & ReturnType<typeof selectBase<T>> {
  return {
    ...selectBase(state),
    data: state.data,
  };
}

export function selectByKey<T extends { byKey: unknown; data: T['data'] } & BaseState>(
  state: T
): { byKey: T['byKey']; data: T['data'] } & ReturnType<typeof selectBase<T>> {
  return {
    ...selectBase(state),
    data: state.data,
    byKey: state.byKey,
  };
}

export function selectById<T extends { byId: unknown; data: unknown } & BaseState>(
  state: T
): { byId: T['byId']; data: T['data'] } & ReturnType<typeof selectBase<T>> {
  return {
    ...selectBase<T>(state),
    data: state.data,
    byId: state.byId,
  };
}

export function selectIsLoading<T extends { isLoading: boolean } & BaseState>(
  state: T
): T['isLoading'] {
  return state.isLoading;
}

// export function selectByOwnerUri<T extends { byOwnerUri: unknown; data: unknown } & BaseState>(
//   state: T,
// ): { byOwnerUri: T['byOwnerUri']; data: T['data'] } & ReturnType<typeof selectBase<T>> {
//   return {
//     ...selectBase(state),
//     data: state.data,
//     byOwnerUri: state.byOwnerUri,
//   };
// }
